import apiCaller from "./api-caller";
import ApiReadonly from "./api-readonly";

class ApiCrud extends ApiReadonly {
  /* CREATE */
  create(record) {
    return apiCaller.post(`/${this.resource}`, record).then((response) => {
      return response.data;
    });
  }

  /* UPDATE */
  update(record) {
    return apiCaller
      .put(`/${this.resource}/${record[this.primaryKey]}`, record)
      .then((response) => {
        return response.data;
      });
  }

  /* UPSERT */
  upsert(record) {
    if (record[this.primaryKey]) {
      return this.update(record);
    }
    return this.create(record);
  }

  /* DELETE */
  delete(record) {
    return apiCaller
      .delete(`/${this.resource}/${record[this.primaryKey]}`)
      .then((data) => {
        return data;
      });
  }
}

export default ApiCrud;
